export default "__VITE_ASSET__kTHJ8jUa__"